import './Tabs.scss';

import { DotsThreeCircle } from '@phosphor-icons/react';
import React, { useRef, useState } from 'react';

import { cn } from '../../helpers/classBuilders';
import { useClassHelper } from '../../hooks';
import type { TabMenuFunction } from './Tabs';

const componentName = 'c-Tabs';

export const TabMenuActions = ({
  actions = [],
  activeTab,
  setActiveTab,
}: {
  setActiveTab: (id: string) => void;
  actions: TabMenuFunction[];
  activeTab: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const c = useClassHelper(componentName);
  const menuRef = useRef(null);

  // Toggle the dropdown menu
  const toggleMenu = () => setIsOpen(!isOpen);

  // Close the menu if clicked outside
  const handleClickOutside = event => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div className={c('__tabMenuActions')} ref={menuRef}>
      <button
        type="button"
        className={cn(c('__tabMenuButton'), 'focus-visible:focus-ring-inset')}
        onClick={toggleMenu}
      >
        <DotsThreeCircle size={32} />
      </button>
      {isOpen && (
        <div className={c('__tabMenuDropdown')}>
          {actions.map(({ label, onClick, disabled }) => {
            const isDisabled = disabled?.(activeTab) || false;
            const handleClick = () => {
              onClick(activeTab, setActiveTab);
              setIsOpen(false);
            };

            return (
              <button
                type="button"
                key={label}
                disabled={isDisabled}
                className={cn(
                  c('__tabItemButton'),
                  'focus-visible:focus-ring-inset',
                  {
                    'hover:bg-gray-100!': !isDisabled,
                  },
                )}
                onClick={handleClick}
              >
                {label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
